import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "idleContainer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "las la-hourglass" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "La aplicación está en reposo", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Vuelva a utilizar el navegador para reanudar", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Su sesión se cerrará pronto", -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (false && _ctx.isIdle && _ctx.store.getters.isUserAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}